import { TaskData } from './../../providers/tasks/models';
import { Component } from '@angular/core';
import {
  NavController,
  NavParams,
  AlertController
} from 'ionic-angular';
import { TaskQL } from '../../providers/tasks/models';
import { TasksProvider } from '../../providers/tasks/tasks';
import { DevicesProvider } from '../../providers/devices/devices';
import { DeviceQL } from '../../providers/devices/models';

@Component({
  selector: 'page-task-test-firealarm',
  templateUrl: 'task-test-firealarm.html'
})
export class TaskTestFirealarmPage {
  inprogress: boolean = false;
  isrepair: string;
  isreplace: boolean;
  task: TaskQL;
  taskData: TaskData;
  testData: any = { passed: true };
  extras: any;
  serial: string;
  device: DeviceQL;
  testPassed: boolean = false;

  // "faultLowBattery": false,
  // "faultSmokeSensor": false,
  // "faultHeatSensor": false,
  // "faultFireAlarm": true,
  // "data": "f0",
  // "fireAlarmStatus": "NORMAL",
  // "lastTestTimestamp": 1544711610000,
  deviceTests: {
    label: string;
    value: string;
    type: 'time' | 'boolean';
    result: boolean;
    state: 'NONE' | 'SUCCEEDED' | 'FAILED';
    resultValue: boolean | number;
  }[] = [
    {
      label: 'Test Time',
      value: 'lastTestTimestamp',
      type: 'time',
      result: null,
      state: 'NONE',
      resultValue: null
    },
    {
      label: 'Fire Alarm',
      value: 'faultFireAlarm',
      type: 'boolean',
      result: null,
      state: 'NONE',
      resultValue: null
    },
    {
      label: 'Heat Sensor',
      value: 'faultHeatSensor',
      type: 'boolean',
      result: null,
      state: 'NONE',
      resultValue: null
    },
    {
      label: 'Smoke Sensor',
      value: 'faultSmokeSensor',
      type: 'boolean',
      result: null,
      state: 'NONE',
      resultValue: null
    },
    {
      label: 'Battery',
      value: 'faultLowBattery',
      type: 'boolean',
      result: null,
      state: 'NONE',
      resultValue: null
    }
  ];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private tasksProvider: TasksProvider,
    private devicesProvider: DevicesProvider,
    private alertCtrl: AlertController
  ) {}

  ionViewDidLoad() {
    this.task = this.tasksProvider.getSelectedTask(); // this.navParams.get('task');
    this.taskData = this.tasksProvider.getTaskData(this.task.id);

    this.extras = this.navParams.get('extras');
    this.isrepair = this.extras.isrepair;

    this.isreplace =
      this.extras && this.extras.isreplace ? this.extras.isreplace : null;

    this.serial = this.isrepair
      ? this.devicesProvider.getSerial(this.taskData.verified)
      : this.devicesProvider.getSerial(this.taskData.code);

    // this.serial = this.serial.substring(0, this.serial.indexOf(";"));
  }

  getReported(value: string) {
    return value &&
      this.device &&
      this.device.active &&
      this.device.active.shadowReference &&
      this.device.active.shadowReference.state &&
      this.device.active.shadowReference.state.reported
      ? this.device.active.shadowReference.state.reported[value]
      : null;
  }

  getMeta(value: string) {
    return value &&
      this.device &&
      this.device.active &&
      this.device.active.shadowReference &&
      this.device.active.shadowReference.metadata &&
      this.device.active.shadowReference.metadata.reported
      ? this.device.active.shadowReference.metadata.reported[value]
      : null;
  }

  initTest() {
    this.inprogress = true;
    this.devicesProvider.getDeviceQL({ serial: this.serial }).subscribe(
      result => {
        this.inprogress = false;
        this.parseResults(result);
      },
      error => console.log(error)
    );
  }
  parseResults(device: DeviceQL) {
    this.device = device;
    this.testPassed = true;

    const stateReported =
      this.device &&
      this.device.active &&
      this.device.active.shadowReference &&
      this.device.active.shadowReference &&
      this.device.active.shadowReference.state
        ? this.device.active.shadowReference.state.reported
        : null;

    const meta =
      this.device &&
      this.device.active &&
      this.device.active.shadowReference &&
      this.device.active.shadowReference &&
      this.device.active.shadowReference.metadata
        ? this.device.active.shadowReference.metadata.reported
        : null;

    this.deviceTests.forEach(test => {
      // test.result = test.type === 'time' ? state[test.value] : meta[test.value] ? meta[test.value].modified_ts : 0;
      // test.state = test.type === 'time' ?
      if (test.type === 'time') {
        test.result = stateReported[test.value];
        test.state =
          !stateReported[test.value] ||
          new Date().getTime() -
            new Date(Number(stateReported[test.value])).getTime() >
            60000
            ? 'FAILED'
            : 'SUCCEEDED';
        test.resultValue = test.state === 'FAILED' ? false : true;
      } else {
        test.result = meta[test.value].modified_ts;
        test.state = stateReported[test.value] ? 'FAILED' : 'SUCCEEDED';
        test.resultValue = stateReported[test.value];
      }

      if (test.state === 'FAILED') {
        this.testPassed = false;
      }
    });

    if (this.testPassed) {
      setTimeout(() => {
        this.testData.passed = true;
        this.updateTask();
      }, 2000);
    } else {
      // for testing
      // this.updateTask();
      this.afterError();
    }
  }

  afterError() {
    this.testData.passed = false;
    if (this.isrepair) {
      // TODO: alert asking to replace or not
      let alert = this.alertCtrl.create({
        title: 'Error',
        message:
          'Test failed. Test can be retried or device needs to be replaced.',
        buttons: [
          {
            text: 'Retry',
            role: 'retry',
            handler: data => {
              // for debugging this.updateTask();
            }
          },
          {
            text: 'Replace',
            role: 'replace',
            handler: data => {
              // for debugging this.updateTask();
              this.tasksProvider
                .updateTaskData(this.task, 'testrepair', 'error')
                .subscribe(data => {
                  // done
                  this.navCtrl.pop();
                });
            }
          }
        ]
      });
      alert.present();
    }
  }

  getValidation(test): 'NONE' | 'FAILED' | 'SUCCEEDED' {
    let state: 'NONE' | 'FAILED' | 'SUCCEEDED' = 'NONE';
    if (
      this.device &&
      this.device.active &&
      this.device.active.shadowReference &&
      this.device.active.shadowReference &&
      this.device.active.shadowReference.state &&
      this.device.active.shadowReference.metadata
    ) {
      const reported = this.device.active.shadowReference.state.reported[
        test.value
      ];
      // const meta = this.device.active.shadowReference.metadata.reported[
      //   test.value
      // ];
      if (test.type === 'time') {
        state =
          new Date().getTime() -
            new Date(reported.lastTestTimestamp).getTime() >
          60000
            ? 'FAILED'
            : 'SUCCEEDED';
      } else {
        state = reported ? 'SUCCEEDED' : 'FAILED';
      }
    }
    return state;
  }

  updateTask() {
    // let data = ['data'];
    let type = !this.isrepair ? 'test' : 'testrepair';
    this.tasksProvider
      .updateTaskData(this.task, type, this.testData)
      .subscribe(data => {
        this.navCtrl.pop();
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/task-test-firealarm/task-test-firealarm.ts